// src/components/Sidebar.js
import { Squash as Hamburger } from "hamburger-react";
import React, { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useClickAway } from "react-use";
import styled from 'styled-components';

const Sidebar = () => {
  const [isOpen, setOpen] = useState(false);
  const ref = useRef(null);
  useClickAway(ref, () => setOpen(false));
  
  return (
    <Container>
      <TopBar>
        <h3>NexBot</h3>
        <Hamburger toggled={isOpen} size={20} toggle={setOpen} />
      </TopBar>
      <Menu className={isOpen ? 'show' : 'hidden'}>
        <MenuItem>
        <NavLink to="/chat" activeClassName="active"><h4>Conversas</h4></NavLink>
        </MenuItem>
        <MenuItem>
          <NavLink to="/chat/recent" activeClassName="active">Recentes</NavLink>
        </MenuItem>
        <MenuItem>
          <NavLink to="/chat/active" activeClassName="active">Ativas</NavLink>
        </MenuItem>
        <MenuItem>
          <NavLink to="/chat/actionable" activeClassName="active">Em espera</NavLink>
        </MenuItem>
        <MenuItem>
          <h4>Loja</h4>
        </MenuItem>
        <MenuItem>
          <NavLink to="/store/products" activeClassName="active">Produtos</NavLink>
        </MenuItem>
        <MenuItem>
          <NavLink to="/store/settings" activeClassName="active">Configurações</NavLink>
        </MenuItem>
      </Menu>
    </Container>
  );
};

const Container = styled.div`
  width: 250px;
  background-color: #2c2c2c;
  color: white;
  display: flex;
  flex-direction: column;
  padding: 20px;
    @media screen and (max-width: 600px) {
    width: 100%;
    
  }
    
`;

const Menu = styled.ul`
  list-style: none;
  padding: 0;

`;

const MenuItem = styled.li`
  margin: 10px 0;

  a {
    color: white;
    text-decoration: none;
    transition: all .2s ease-in-out;

    &.active {
      font-weight: bold;
    }
  }

  :hover {
    padding: 2px;
    color: #ebebeb;
  }
`;

const TopBar = styled.div`
  display: flex;
  width: 100%;
  :nth-child(2){
    display: none;
  }
    @media screen and (max-width: 600px) {
      width: 90%;
      justify-content: space-between;
        :nth-child(2){
          display: block;
        }
    }
`;

export default Sidebar;
